import * as Scrivito from "scrivito";
import I18n from "^/config/i18n";
import { isEqual } from "lodash-es";

function EventDate({ event, className = "", icon = false }) {
  const date = event.get("date")?.setHours(0, 0, 0);
  const end = event.get("endDate")?.setHours(0, 0, 0);

  if (!date) {
    return null;
  }
  return (
    <div className={`d-flex align-items-center ${className}`}>
      {icon && <i className="las la-calendar me-1" />}
      <EventDateString date={date} />
      {!isEqual(date, end) && (
        <>
          <div className="d-block text-center mx-2">|</div>
          <EventDateString date={end} />
        </>
      )}
    </div>
  );
}

const EventDateString = ({ date }) => (
  <time dateTime={new Date(date).toISOString().slice(0, 10)}>
    {I18n.t("eventDate", {
      val: date,
      formatParams: {
        val: {
          day: "numeric",
        },
      },
    })}
    {I18n.resolvedLanguage === "de" ? "." : ""}
    {` ${I18n.t("eventDate", {
      val: date,
      formatParams: {
        val: {
          month: "long",
        },
      },
    })}`}
  </time>
);

export default Scrivito.connect(EventDate);
